import attractionsFile from '../../content/places/arenal/attractions.json'
import historyFile from '../../content/places/arenal/history.json'
import questsFile from '../../content/places/arenal/quests.json'
import type { Attraction, HistoryEvent, Quest, Settlement, TraversalId } from '../types'

const attractions = attractionsFile.attractions as Attraction[]
const settlements = attractionsFile.settlements as Settlement[]
const events = historyFile.events as HistoryEvent[]
const quests = questsFile.quests as Quest[]

export function loadWorldContent(): {
  attractions: Attraction[]
  settlements: Settlement[]
  history: HistoryEvent[]
  quests: Quest[]
} {
  return {
    attractions,
    settlements,
    history: [...events].sort((a, b) => a.year - b.year),
    quests: [...quests].sort((a, b) => a.order - b.order),
  }
}

export function attractionsByTier(tier: Attraction['tier']): Attraction[] {
  return attractions.filter((attraction) => attraction.tier === tier)
}

export function attractionsForTraversal(mode: TraversalId): Attraction[] {
  return attractions.filter((attraction) => attraction.traversal?.includes(mode))
}

/** Attractions anchored to an authored hotspot, keyed by hotspot id. */
export function attractionsByHotspot(): Map<string, Attraction> {
  return new Map(
    attractions.flatMap((attraction) =>
      attraction.hotspotId ? [[attraction.hotspotId, attraction] as const] : [],
    ),
  )
}

/** Entries still awaiting source or coordinate confirmation. */
export function unverifiedEntries(): Array<Attraction | Settlement | HistoryEvent> {
  return [...attractions, ...settlements, ...events].filter(
    (entry) => entry.needsVerification === true,
  )
}
